<mat-card>
    <mat-card-content style="display: flex; gap: 10px; flex-direction: column;">
        <div fxLayout="row wrap" class="accordianBox">
            <div class="description" fxLayout="row">
                <i class="flaticon-flag"></i>
                <div fxLayout="column">
                    <span class="title">Landing Page</span>
                    <span>You can choose the default landing page after login.</span>
                </div>
            </div>
            <div class="actions">
                <app-select-field [isEditable]="isDefaultPageEditable" [(ngModel)]="selectedMenu"
                                  [name]="'default_page'" [idField]="null" [displayField]="'name'" [searchable]="true"
                                  [options]="pageList?.results" [errors]="error.default_page" fxFlex="16em">
                </app-select-field>

                <i class="flaticon-{{isDefaultPageEditable ? 'save' : 'pencil'}}" (click)="editableToggle()"></i>
            </div>
            <!-- <button mat-raised-button class="Save" (click)="saveLandingPage()">Save</button> -->
        </div>
        <div fxLayout="row wrap" class="accordianBox">
            <div class="description" fxLayout="row">
                <i class="flaticon-flag"></i>
                <div fxLayout="column">
                    <span class="title">Skip Landing Page</span>
                    <span>You can choose to skip landing page and directly navigate to List page of any process.</span>
                </div>
            </div>
            <div class="actions">
                <mat-checkbox [(ngModel)]="skipTutorial" [disabled]="!isSkipLandingPage">
                </mat-checkbox>
                <i class="flaticon-{{isSkipLandingPage ? 'save' : 'pencil'}}" (click)="editableLandingToggle()"></i>
            </div>
            <!-- <button mat-raised-button class="Save" (click)="saveLandingPage()">Save</button> -->
        </div>
    </mat-card-content>
</mat-card>
